export default __webpack_public_path__ + "static/media/Emblem_Challenger.081b8e25.webp";